<div class="fs-2 with-close" mat-dialog-title [ngClass]="{'success': step == 3}">
    Donnez-nous votre avis
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <ng-container *ngIf="step == 0">
        Et si on vous offrait <b>7 jours gratuits</b> sur LyBox ? 🎁<br/>
        <br/>
        <b>Comment ?</b><br/>
        <br/>
        Rien de plus simple : <b>Donnez-nous votre avis !</b><br/>
        (Cela ne prendra qu’une minute).<br/>
        <br/>
        Pour continuer à améliorer l’outil, nous avons besoin de votre <b>retour d’expérience</b>.<br/>
        <br/>
        En échange, nous vous offrons <b>7 jours gratuits</b> sur le forfait “Essentiel”. 🎁<br/>
        <br/>
        P.S : <b>5 étoiles</b> ça fait toujours plaisir 😉<br/>
        <br/>
        <i>Cette offre est à durée limitée, et sera automatiquement désactivée ensuite. ⏰</i><br/>
        <br/>
        <div class="text-center">
            <button (click)="startRate()" type="button" class="btn btn-primary w-100">
                Profiter de 7 jours gratuits 🎁
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="step == 1">
        <div class="row">
            <div class="col-md-6">
                <star-rating labelText="Facilité d'utilisation" size="large"
                             labelPosition="top" [step]="1" [numOfStars]="5"
                             (ratingChange)="onEasyClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-md-6">
                <star-rating labelText="Moteur de recherche" size="large" labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onSearchClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-md-6">
                <star-rating labelText="Simulateur de fiscalité" size="large"
                             labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onSimulClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div class="col-md-6">
                <star-rating labelText="Note générale" size="large" labelPosition="top"
                             [step]="1" [numOfStars]="5"
                             (ratingChange)="onGeneralClick($event)" [hoverEnabled]="true"
                             [showHalfStars]="true" [starType]="'svg'"
                             [rating]="0"></star-rating>
            </div>
            <div>
                <div class="label-value">Commentaires</div>
                <textarea class="comment-text" matInput [(ngModel)]="comment"></textarea>
                <br/>
                <button (click)="onSubmit()" class="btn btn-primary mt-3 w-100">
                    Valider mon avis
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="step == 2">
        <p *ngIf="general == 5">

            <b>Merci pour cet avis 5 étoiles ! ⭐️</b><br/>
            <br/>
            <b>J’ai un dernier service à vous demander</b> : Partager cet avis 5 étoiles pour nous aider à nous
            développer !<br/>
            <br/>
            Un grand merci ! 🙏<br/>
        </p>

        <div *ngIf="general == 5 && comment" class="copy-review-box">
            <div class="copy-review-label">📋 Votre avis (cliquez pour copier) :</div>
            <div class="copy-review-content" (click)="copyReview()">
                {{ comment }}
            </div>
            <div class="copy-review-status" *ngIf="copied">✅ Copié ! Vous pouvez le coller sur {{ platform == 'google' ? 'Google' : 'Trustpilot' }}</div>
        </div>

        <p *ngIf="general == 5" class="text-center mb-0">
            <ng-container *ngIf="platform == 'google'">
                <a target="_blank" href="https://g.page/r/CfLXR1zgHm-IEBM/review" (click)="step = 3" class="rate"><img
                    src="assets/recuperer-google-avis-client.jpg" alt="Avis google"/></a>
                <br/>
                <a target="_blank" href="https://g.page/r/CfLXR1zgHm-IEBM/review" (click)="step = 3"
                   class="btn btn-primary mt-3 w-100">Mettre mon avis 5⭐️ sur Google</a>
            </ng-container>
            <ng-container *ngIf="platform == 'trustpilot'">
                <a target="_blank" href="https://fr.trustpilot.com/evaluate/www.lybox.fr?stars=5" (click)="step = 3"
                   class="rate"><img src="assets/trustpilot.png" alt="Avis Trustpilot"/></a>
                <br/>
                <a target="_blank" href="https://fr.trustpilot.com/evaluate/www.lybox.fr?stars=5" (click)="step = 3"
                   class="btn btn-primary mt-3 w-100">Mettre mon avis 5⭐️ sur Trustpilot</a>
            </ng-container>
        </p>
        <p *ngIf="general != 5">
            <b>Merci pour votre avis !</b><br/>
            Nous avons bien pris en compte vos remarques et nous faisons le maximum pour améliorer l'application.<br/>
            Vos retours sont très importants pour les futurs développements et pour construire la meilleure application
            pour vos investissements immobiliers
        </p>
    </ng-container>
    <ng-container *ngIf="step == 3">
        <b>Félicitations, vos 7 jours gratuits ont bien été validés !</b>
        <br/>
        <p class="text-center mt-4 mb-4">
            <img src="assets/party%20popper.png">
        </p>
        <p>Vous avez dès maintenant accès à toutes les fonctionnalités de votre forfait Essentiel !</p>
        <p class="mb-0">Il est temps de trouver des biens rentables 🏢<br/><br/></p>
        <div class="text-center">
            <button (click)="onNoClick()" type="button" class="btn btn-outline-primary w-100">
                Fermer
            </button>
        </div>
    </ng-container>
</div>
